import { useState } from "react";
import { Box, Container, Stepper, Text } from "@mantine/core";
import { Fade } from "react-reveal";

const Events = () => {
	const [active, setActive] = useState(5);

	const days = [
		{
			id: 1,
			label: "FYB Day 1: 26 July 2023",
			title: "Jersey Day",
			description: `		On the exhilarating first day of FYB week, university students
									showcase their sports spirit by donning vibrant jerseys of
									their favorite teams. The campus buzzes with excitement as
									each student proudly wears their team's colors, bringing an
									electrifying atmosphere to the halls. From football to
									basketball, and everything in between, the jerseys become more
									than just outfits; they become symbols of unity and passion,
									uniting students from diverse backgrounds under the common
									language of sports.`,
		},
		{
			id: 2,
			label: "FYB Day 2: 27 July 2023",
			title: "Denim on Denim Day",
			description: `As the sun rises on the second day of FYB week, the campus
								transforms into a trendy runway with students stepping out in
								style, embracing the classic Denim on Denim look. Denim jackets
								paired with jeans, skirts, or shorts create an effortlessly cool
								ensemble that never goes out of fashion. The quad becomes a sea
								of denim, each student putting their own spin on the timeless
								trend. Amidst the laughter and camaraderie, friendships are
								forged, and memories are etched in denim-clad hearts.`,
		},
		{
			id: 3,
			label: "FYB Day 3: 28 July 2023",
			title: "Ankara Day",
			description: `The rhythm of cultural diversity resonates on the third day of
								FYB week as students proudly celebrate their African heritage by
								adorning striking Ankara prints. The campus transforms into a
								kaleidoscope of colors and patterns, reflecting the richness of
								African culture and traditions. From bold dresses to tailored
								suits, the beauty of Ankara radiates through every outfit,
								telling unique stories of identity, belonging, and heritage.`,
		},
		{
			id: 4,
			label: "FYB Day 4: 02 Aug 2023",
			title: "Corporate Day",
			description: `With determination in their stride and confidence in their eyes,
								students embark on the fourth day of FYB week dressed in sharp
								and sophisticated corporate attire. The halls of academia become
								a corporate hub, mirroring the future workplaces these budding
								professionals aspire to enter. Clad in power suits, pencil
								skirts, and crisp shirts, the students exude professionalism,
								leaving a lasting impression on professors, peers, and potential
								employers alike.`,
		},
		{
			id: 5,
			label: "FYB Day 5 : 03 Aug 2023",
			title: "Sign Out and Birthday Celebration",
			description: `The much-awaited culmination of FYB week arrives with an
								extraordinary display of sentimental camaraderie and heartfelt
								memories. On this final day, students don plain white vests or
								shirts, symbolizing a blank canvas awaiting the imprint of
								cherished memories. With beaming smiles and teary eyes, they
								stand together while friends, coursemates, and beloved family
								members come forward to leave their mark.
							
								For Meena, it doubles as a birthday celebration, and she enjoyed her day with the presence of her friends and boyfriend.
								`,
		},
	];

	return (
		<Box bg="main.0" py={50}>
			<Container>
				<Fade bottom>
					<Text
						align="center"
						fw="bold"
						fz={32}
						mb="lg"
						color="purple"
						tt="uppercase"
					>
						<Text component="span" style={{ borderBottom: "3px purple solid" }}>
							FYB Time-line
						</Text>
					</Text>
				</Fade>

				<Stepper active={active} onStepClick={setActive} orientation="vertical">
					{days.map((day) => (
						<Stepper.Step
							key={day.id}
							label={<Fade bottom>{day.label}</Fade>}
							description={
								<Fade bottom>
									<Text align="justify" mb={20}>
										<Text color="purple" fw="bold">
											{day.title} :{" "}
										</Text>
										{day.description}
									</Text>
								</Fade>
							}
						/>
					))}
				</Stepper>
			</Container>
		</Box>
	);
};

export default Events;
